import { LanguageKey } from "@constants/template";
import { proxy } from "valtio";
import { defaultMessage } from "../constants";

interface BannerItem {
    Url: string;
    Name: string;
    Type: string;
    Extension: string;
}

interface Store {
    coverPage: {
        banner: {
            Desktop: BannerItem[];
            Mobile: BannerItem[];
        };
        section1: { Desktop: BannerItem[]; Mobile: BannerItem[] };
        section2: { Desktop: BannerItem[]; Mobile: BannerItem[] };
        section3: { Desktop: BannerItem[]; Mobile: BannerItem[] };
        section4: { Desktop: BannerItem[]; Mobile: BannerItem[] };
    };
    deletedId: string;
    isDeleteModalOpened: {
        Bannier: boolean;
        Section1: boolean;
        Section2: boolean;
        AdvertisingImage: boolean;
    };
    selectedLanguage: LanguageKey;
    informationMessageItems: typeof defaultMessage;
    path: string;
}

export const store: Store = proxy({
    coverPage: {
        banner: { Desktop: [], Mobile: [] },
        section1: { Desktop: [], Mobile: [] },
        section2: { Desktop: [], Mobile: [] },
        section3: { Desktop: [], Mobile: [] },
        section4: { Desktop: [], Mobile: [] },
    },
    deletedId: "",
    isDeleteModalOpened: {
        Bannier: false,
        Section1: false,
        Section2: false,
        AdvertisingImage: false,
    },
    selectedLanguage: "FR",
    informationMessageItems: defaultMessage,
    path: "",
});

export function setBanner(type: "Desktop" | "Mobile", value: BannerItem[]) {
    store.coverPage.banner[type] = value;
}

export function setDeletedId(deletedId: string): void {
    store.deletedId = deletedId;
}

type DeleteModalSection = keyof Store["isDeleteModalOpened"];
export function setIsDeleteModalOpened(
    section: DeleteModalSection,
    value: boolean
) {
    store.isDeleteModalOpened[section] = value;
}

export function setSelectedLanguage(selectedLanguage: LanguageKey): void {
    store.selectedLanguage = selectedLanguage;
}

export function setInformationMessageItems(
    informationMessageItems: typeof defaultMessage
): void {
    store.informationMessageItems = informationMessageItems;
}

export function setPath(path: string): void {
    store.path = path;
}
